import React, { useEffect } from "react";
import { GridColDef } from "@mui/x-data-grid-premium";
import { TableContainer } from "@mui/material";
import DataGridTable from "../../base/DataGridTable";
import { useDispatch, useSelector } from "../../../store";
import { fetchConnections } from "../../../slices/connection";
import TableActions from "../../base/TableActions";

interface Props {
  handleEdit?: (id: number) => void;
  handleDelete?: (id: number) => void;
}

const ConnectionsTable: React.FC<Props> = (props) => {
  const { handleEdit, handleDelete } = props;

  const dispatch = useDispatch();
  const { connectionList, status } = useSelector((store) => store.connection);

  useEffect(() => {
    dispatch(fetchConnections());
  }, [dispatch]);

  const rows =
    connectionList &&
    connectionList.map((connection) => {
      let rowObject = {
        id: connection.id,
        name: connection.name,
        connectionType: connection.connectionType?.value,
        systemType: connection.systemType?.value,
        authenticationType: connection.authenticationType?.value,
        server: connection.server || connection.tenant,
        actions: (
          <TableActions
            id={connection.id!}
            handleEdit={() => handleEdit!(connection.id!)}
            handleDelete={() => handleDelete!(connection.id!)}
          />
        ),
      };

      return rowObject;
    });

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "server",
      headerName: "Server / Tenant Id",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "connectionType",
      headerName: "Connection Type",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "systemType",
      headerName: "System",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "authenticationType",
      headerName: "Authentication Type",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      disableExport: true,
      renderCell: (params) => <>{params.value}</>,
      headerClassName: "header",
    },
  ];

  return (
    <TableContainer>
      <DataGridTable
        columns={columns}
        rows={rows || []}
        loading={status === "loading"}
      />
    </TableContainer>
  );
};

export default ConnectionsTable;
